export class Serie{
    public constructor(
        public id:string = "",
        public codigo :string = "",
        public inventario_id: string = "",
        public status: string = "",
        public usuario_id: string = null,
        public is_selected: boolean = false,
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/serie.ts